export default __webpack_public_path__ + "static/media/imgLoja01.201ead77.png";